import { FilterInfoOperator } from '@ardoq/api-types';

export const standardComparators = [
  FilterInfoOperator.EQUALS,
  FilterInfoOperator.CONTAINS,
  FilterInfoOperator.GREATER_THAN,
  FilterInfoOperator.LESS_THAN,
];

export const selectComparators = [
  FilterInfoOperator.EQUALS,
  FilterInfoOperator.CONTAINS,
];

export const dateComparators = [
  FilterInfoOperator.DATE_MATCH,
  FilterInfoOperator.DATE_EARLIER,
  FilterInfoOperator.DATE_LATER,
];

export const dateRangeComparators = [
  FilterInfoOperator.DATE_RANGE_CONTAINS,
  FilterInfoOperator.DATE_RANGE_DOES_NOT_CONTAIN,
  FilterInfoOperator.DATE_RANGE_BEFORE,
  FilterInfoOperator.DATE_RANGE_AFTER,
];

export const idMatchComparators = [FilterInfoOperator.ID_MATCH];

export const booleanComparators = [FilterInfoOperator.BOOLEAN];
